/**
 * Envelope padrão da API CTF — espelha `ServiceModel.Model<T>` do backend.
 * Usado por `ListarSessoes`, `ObterSessao` e `BuscarCombustiveis`.
 *
 * `InserirPreautorizacao` NÃO usa este envelope: o controller faz
 * `Ok(processamento.Retorno)`, retornando o objeto direto.
 */
export interface SwapApiResponse<T> {
  sucesso: boolean;
  mensagens: string[];
  retorno?: T;
}
